import { make } from "vuex-pathify";
import { CollateralManagementService } from "../services/collateral-management.service.js";
import Logger from "@/lib/logger.js";

const service = new CollateralManagementService();

export const state = {
  collaterals: [],
  totalCollaterals: []
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  async createCollateral({ dispatch }, collateralInfo) {
    try {
      const { data } = await service.createCollateral(collateralInfo);
      return data;
    } catch (error) {
      Logger.error('Creating Collateral');
      throw error;
    }
  },

  async getCollaterals({ commit }, pagination) {
    try {
      const { data } = await service.getCollaterals(pagination?.page, pagination?.limit, pagination?.order, pagination?.sort, pagination?.search, pagination?.type, pagination?.isForeclosed);
      commit('SET_COLLATERALS', data.collaterals);
      commit('SET_TOTAL_COLLATERALS', data.total);
      return data;
    } catch (error) {
      Logger.error('Fetching Collateral');
      throw error;
    }
  },

  async getCollateral(_, id) {
    try {
      const { data } = await service.getCollateral(id);
      return data;
    } catch (error) {
      Logger.error('Fetching A Collateral');
      throw error;
    }
  },

  async updateCollateral({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateCollateral(id, updates);
      return data;
    } catch (error) {
      Logger.error('Updating Collateral');
      throw error;
    }
  },

  async deleteCollateral({ dispatch }, id ) {
    try {
      const { data } = await service.deleteCollateral(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Collateral');
      throw error;
    }
  },

  async createCollateralOwner({ dispatch }, { owner, ownerCollateralId }) {
    try {
      const { data } = await service.createCollateralOwner(owner, ownerCollateralId);
      return data;
    } catch (error) {
      Logger
      Logger.error('Creating Collateral Owner');
      throw error;
    }
  },

  async updateCollateralOwner({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateCollateralOwner(id, updates);
      return data;
    } catch (error) {
      Logger.error('Updating Collateral Owner');
      throw error;
    }
  },

  async deleteCollateralOwner({ dispatch }, id) {
    try {
      const { data } = await service.deleteCollateralOwner(id);
      return data;
    } catch (error) {
      Logger.error('Deleting Collateral Owner');
      throw error;
    }
  },

  async addOwnerToCollateral({ dispatch }, { collateralId, ownerId, ownerInfo }) {
    try {
      const { data } = await service.addOwnerToCollateral(collateralId, ownerId, ownerInfo);
      return data;
    } catch (error) {
      Logger.error('Adding Collateral Owner to Collateral');
      throw error;
    }
  },

  async removeOwnerFromCollateral({ dispatch }, { collateralId, ownerId, ownerInfo }) {
    try {
      const { data } = await service.removeOwnerFromCollateral(collateralId, ownerId, ownerInfo);
      return data;
    } catch (error) {
      Logger.error('Removing Collateral Owner to Collateral');
      throw error;
    }
  },

  async findCollateralByOwner({ commit }, { pagination, payload }) {
    try {
      const { data } = await service.findCollateralByOwner(pagination.page, pagination.limit, payload);
      commit('SET_COLLATERALS', data.collaterals);
      return data;
    } catch (error) {
      Logger.error('Removing Collateral Owner to Collateral');
      throw error;
    }
  },

  async saveRiskFactorScoring(_, { collateralId, riskScoring }) {
    try {
      const { data } = await service.saveRiskFactorScoring(collateralId, riskScoring);
      return data;
    } catch (error) {
      Logger.error('Saving Risk Factor Scoring');
      throw error;
    }
  }
};
